<div class="form-group mb-3">
  <ng-container *ngIf="label">
    <app-label-info *ngIf="label"
      >{{ label }} <span [class.invalid]="invalid" *ngIf="_required">*</span></app-label-info
    >
  </ng-container>

  <div class="ui-inputgroup" [ngClass]="{ 'invalid-control': invalid }">
    <p-fileUpload
      [showUploadButton]="false"
      [showCancelButton]="false"
      (onSelect)="onFileChange($event)"
      (onRemove)="onFileClear($event)"
      [chooseLabel]="chooseLabel"
      [disabled]="disabled"
      [files]="remoteFile"
      accept="{{ accept }}"
    ></p-fileUpload>
  </div>

  <partnerhub-error-validation *ngIf="dirty || formSubmitted" [errors]="errors"> </partnerhub-error-validation>
</div>
